type OnboardingData = {
  goal?: string | null
  destination?: string | null
  timeline?: string | null
  originCity?: string | null
  originCountry?: string | null
  originCountryCode?: string | null
  age?: string | null
  savings?: string | null
  situation?: string | null
}

const ONBOARDING_STEPS: { field: keyof OnboardingData; route: string }[] = [
  { field: 'goal', route: '/onboarding' },
  { field: 'destination', route: '/onboarding/destination' },
  { field: 'timeline', route: '/onboarding/timeline' },
  { field: 'originCountryCode', route: '/onboarding/origin' },
  { field: 'age', route: '/onboarding/age' },
  { field: 'savings', route: '/onboarding/savings' },
  { field: 'situation', route: '/onboarding/situation' },
]

export function getFirstIncompleteOnboardingStep(data: OnboardingData | null): string | null {
  if (!data) return '/onboarding'

  for (const step of ONBOARDING_STEPS) {
    const value = data[step.field]
    if (!value || (typeof value === 'string' && value.trim() === '')) {
      return step.route
    }
  }

  return null
}

export function parseOnboardingData(raw: string | null): OnboardingData | null {
  if (!raw) return null
  try {
    return JSON.parse(raw) as OnboardingData
  } catch {
    return null
  }
}
